var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetappOverlayMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 361,
    viewBox: "0 0 390 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-309.165 -837.488C-309.165 -837.488 1616.54 -941.28 1742.36 -948.062C1868.17 -954.843 2138.67 24.0273 1807.67 263.527C1476.67 503.027 563.163 206.576 -212.241 350.016C-987.645 493.456 -309.165 -837.488 -309.165 -837.488Z",
    fill: "url(#paint0_linear_7254_134300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7254_134300",
    x1: 647.314,
    y1: -889.041,
    x2: 716.686,
    y2: 398.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC686E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83F45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetappOverlayMobile);
export default __webpack_public_path__ + "static/media/getapp-overlay-mobile.52e963720fc973886d6322c61e86c086.svg";
export { ForwardRef as ReactComponent };